export default {"src":"/_next/static/media/logout.b87ced4b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};